import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Suppliers/Statement/tables";
import headers from "../../../../Data/Tables/Suppliers/Statement/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { useParams } from "react-router-dom";
import { get_all_lpos } from "../../../../Controllers/Purchases/Lpos";
import { get_all_purchases } from "../../../../Controllers/Purchases/Orders";

const SupplierOutstandingStatement = () => {
  const [loader, setLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [body, setBody] = useState([]);
  const [summary, setSummary] = useState({
    totalOutstanding: 0,
    totalPurchases: 0,
    totalAmount: 0,
    overdueAmount: 0,
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  });

  const { id } = useParams();
  localStorage.setItem("Supplier_Id", id)

  const paginationdata = (data) => {
    let headerdata = {};
    header?.components?.map((value) => {
      headerdata[value.name] = value.value;
    });

    fetchData({
      ...data,
      search: headerdata?.search,
      supplier: headerdata?.supplier,
      status: headerdata?.status,
      date: headerdata?.date,
    });
  };

  const formdata = (data) => {
    let page = data?.search ? pagination?.currentPage : 1;
    fetchData({
      ...data,
      currentPage: page,
      totalCount: pagination?.totalCount,
      totalPages: pagination?.totalPages,
    });
  };

  const calculateTotalPaid = (purchase) => {
    console.log("purchasse", purchase);
    if (!purchase?.payments || !Array.isArray(purchase?.payments)) return 0;
    return purchase?.payments.reduce(
      (sum, payment) => sum + (payment.amount || 0),
      0
    );
  };

  const calculateOutstanding = (purchase, lpoData) => {
    const total = lpoData?.total || 0;
    const paid = calculateTotalPaid(purchase);
    return total - paid;
  };

  const isOverdue = (lpoData) => {
    if (!lpoData?.due_date) return false;
    return new Date(lpoData.due_date) < new Date();
  };

  const combinePurchaseData = async (lposData, purchasesData) => {
    const purchaseMap = {};
    purchasesData.forEach((purchase) => {
      purchaseMap[purchase.number] = purchase;
    });

    const combinedData = lposData.map((lpo) => {
      const purchase = purchaseMap[lpo.number];
      return {
        lpoData: lpo,
        purchaseData: purchase,
      };
    });

    return combinedData;
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const params = {
        search: tabledata?.search,
        supplier: tabledata?.supplier || id,
        status: tabledata?.status,
        date: tabledata?.date,
        page: tabledata?.currentPage || 1,
        limit: 10,
        source: "Supplier-Outstanding-Statement",
      };

      const [lposResponse, purchasesResponse] = await Promise.all([
        get_all_lpos(params),
        get_all_purchases(params),
      ]);

      if (lposResponse?.status && purchasesResponse?.status) {
        const lposData = lposResponse?.data?.data || [];
        const purchasesData = purchasesResponse?.data?.data || [];

        const combinedData = await combinePurchaseData(lposData, purchasesData);

        const filteredData = combinedData.filter((item) => {
          const outstanding = calculateOutstanding(
            item.purchaseData,
            item.lpoData
          );
          return outstanding > 0;
        });

        const startIndex = (params.page - 1) * params.limit;
        const paginatedData = filteredData.slice(
          startIndex,
          startIndex + params.limit
        );

        let totalOutstanding = 0;
        let totalAmount = 0;
        let overdueAmount = 0;

        const tableData = paginatedData.map((item) => {
          const { lpoData, purchaseData } = item;

          const outstanding = calculateOutstanding(purchaseData, lpoData);
          const paidAmount = calculateTotalPaid(purchaseData);
          const overdue = isOverdue(lpoData);

          totalOutstanding += outstanding;
          totalAmount += lpoData.total || 0;
          if (overdue && outstanding > 0) overdueAmount += outstanding;

          return {
            path: `/app/purchases/lpo/view/${lpoData?._id}`,
            "PO Number": `#PO-${lpoData.number}`,
            Supplier: lpoData.supplier?.name || "N/A",
            Date: new Date(lpoData.date).toLocaleDateString(),
            "Due Date": lpoData.due_date
              ? new Date(lpoData.due_date).toLocaleDateString()
              : "-",
            "Total Amount": `OMR ${(lpoData.total || 0).toFixed(3)}`,
            "Paid Amount": `OMR ${paidAmount.toFixed(3)}`,
            Outstanding: `OMR ${outstanding.toFixed(3)}`,
            "Payment Status":
              purchaseData?.payment_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Paid
                </span>
              ) : purchaseData?.payment_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Unpaid
                </span>
              ),
            "Delivery Status":
              purchaseData?.delivery_status == 2 ? (
                <span className="bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
                  Delivered
                </span>
              ) : purchaseData?.delivery_status == 1 ? (
                <span className="bg-yellow-100 text-yellow-600 text-sm px-2 py-1 rounded-lg">
                  Partial
                </span>
              ) : (
                <span className="bg-red-100 text-red-600 text-sm px-2 py-1 rounded-lg">
                  Pending
                </span>
              ),
          };
        });

        setBody(tableData);

        setSummary({
          totalOutstanding,
          totalPurchases: filteredData.length,
          totalAmount,
          overdueAmount,
        });

        setPagination({
          currentPage: params.page,
          totalCount: filteredData.length,
          totalPages: Math.ceil(filteredData.length / params.limit),
        });
      } else {
        const errorMessage =
          lposResponse?.message ||
          purchasesResponse?.message ||
          "Failed to fetch supplier data";
        toast.error(errorMessage);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoader(false);
    }
  };

  const headerReset = () => {
    let componentData = [];
    headers?.components?.map((value) => {
      componentData?.push({
        ...value,
        value: null,
      });
    });
    setHeader({ ...headers, components: componentData });
  };

  useEffect(() => {
    if (id) {
      fetchData();
    }
    headerReset();
  }, [id]);

  return (
    <div>
      <Header headers={header} setHeaders={setHeader} formdata={formdata}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 pt-4">
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Outstanding</h3>
            <p className=" text-red-600">
              OMR {summary.totalOutstanding.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Purchases</h3>
            <p className=" text-green-600">{summary.totalPurchases}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Total Amount</h3>
            <p className=" text-green-600">
              OMR {summary.totalAmount.toFixed(3)}
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <h3 className=" text-gray-700 mb-2">Overdue Amount</h3>
            <p className=" text-orange-600">
              OMR {summary.overdueAmount.toFixed(3)}
            </p>
          </div>
        </div>
        <Loadercomponent loader={loader}>
          <Table
            head={tables}
            body={body}
            pagination={pagination}
            paginationdata={paginationdata}
          />
        </Loadercomponent>
      </Header>
    </div>
  );
};

export default SupplierOutstandingStatement;
